import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../../../../../../common/element/Table";
import Button from "../../../../../../../common/element/Buttons";
import { useNavigate, useLocation } from "react-router-dom";
import DeleteModal from "../../../../../../../common/Common/DeleteModal";
import ThreeDotBouncingLoader from "../../../../../../../common/element/ButtonLoader/ThreeDotBouncingLoder";
import { removeCompanyCoach, clearRemoveCompanyCoach, getCompanyCoaches } from "../../../../../../../redux/Companies/companiesSlice";
import {
    selectRemoveCompanyCoachLoading,
    selectRemoveCompanyCoachError
} from "../../../../../../../redux/Companies/companiesSelector";
import SweetAlertService from "../../../../../../../common/SweetAlert/SweetAlert";
import { selectUserData } from "../../../../../../../redux/auth/authSelector";
import moment from "moment";
import CommonIconButton from "../../../../../../../common/icons/CommonIconButton";
const { Tr, Th, Td, THead, TBody } = Table;

const CompanyCoachesList = ({ sampleData = [], loading, onEdit, companyData }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const searchParams = new URLSearchParams(location.search);
    const companyId = searchParams.get("companyId");
    const tab = searchParams.get("tab");
    console.log(companyId, "companyIdcompanyId")
    const [isOpen, setIsOpen] = useState(false);
    const [selectedCoachId, setSelectedCoachId] = useState(null);

    const deleteLoading = useSelector(selectRemoveCompanyCoachLoading);
    const deleteError = useSelector(selectRemoveCompanyCoachError);
    const userData = useSelector(selectUserData);
    const isActiveCompany = companyData?.hasOwnProperty('company_isActive') ? companyData?.company_isActive : userData?.company_isActive;

    const handleDeleteClick = (coachId) => {
        setSelectedCoachId(coachId);
        setIsOpen(true);
    };
    console.log(selectedCoachId, "selectedCoachIdselectedCoachId")
    const handleDelete = async () => {
        if (!selectedCoachId || !companyId) return;

        try {
            await dispatch(
                removeCompanyCoach({
                    coachId: Number(selectedCoachId),   // ✅ convert to number
                    companyId: Number(companyId)        // ✅ convert to number
                })
            ).unwrap();

            SweetAlertService.showSuccess({
                title: "Success!",
                message: "Coach removed successfully",
            });

            setIsOpen(false);
            setSelectedCoachId(null);

            dispatch(getCompanyCoaches({
                companyId: Number(companyId),
                page: 1,
                limit: 10
            }));

            dispatch(clearRemoveCompanyCoach());
        } catch (error) {
            console.log(error, "errorerror")
            SweetAlertService.showError({
                title: "Error!",
                message: error || "Failed to remove coach",
            });
        }
    };

    const handleModalClose = () => {
        setIsOpen(false);
        setSelectedCoachId(null);
        dispatch(clearRemoveCompanyCoach());
    };

    if (loading) {
        return (
            <ThreeDotBouncingLoader />
        );
    }

    return (
        <div className="border rounded-lg border-gray-200">
            <Table>
                <THead>
                    <Tr className="text-start">
                        <Th>S No.</Th>
                        <Th>Name</Th>
                        <Th>Email</Th>
                        <Th>No. of sessions conducted</Th>
                        <Th>Last session conducted</Th>
                        {isActiveCompany && <Th>Action</Th>}
                    </Tr>
                </THead>
                <TBody>
                    {sampleData.length > 0 ? (
                        sampleData.map((item, index) => (
                            <Tr key={item.id} className="text-center">
                                <Td>{String(index + 1).padStart(2, "0")}</Td>
                                <Td className="text-start">{item.first_name + " " + item.last_name}</Td>
                                <Td className="text-start">{item.email}</Td>
                                <Td className="text-start">{item.no_of_sessions_conducted || "--"} </Td>
                                <Td className="text-start"> {item.last_session_conducted || item.last_session_conducted
                                    ? moment(item.last_session_conducted || item.last_session_conducted).format("LL")
                                    : "—"}</Td>
                                {isActiveCompany && <Td>
                                    <div className="flex gap-1 justify-start">
                                        <CommonIconButton
                                        type="delete"
                                            onClick={() => handleDeleteClick(item.coach_id)}
                                            disabled={deleteLoading}
                                        />
                                           
                                    </div>
                                </Td>}

                            </Tr>
                        ))
                    ) : (
                        <Tr>
                            <Td colSpan={6} className="text-center py-6 text-gray-500">
                                No coaches found
                            </Td>
                        </Tr>
                    )}
                </TBody>
            </Table>

            <DeleteModal
                dialogOpen={isOpen}
                onDialogClose={handleModalClose}
                onConfirm={handleDelete}
                title="Are you sure you want to delete this coach?"

                loading={deleteLoading}
            />
        </div>
    );
};

export default CompanyCoachesList;